import React, { useState, useEffect } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { Cnt } from "../Cnt.ThreeDeeCrate.SDK/Cnt.ThreeDeeCrate.SDK";
import { EMPTY_GUID } from "../types/Guid";

interface ModelFormProps {
  show: boolean;
  onClose: () => void;
  onSave: (model: Cnt.ThreeDeeCrate.SDK.CreateUpdateModelDTO) => void;
  styleFilter: Cnt.ThreeDeeCrate.SDK.GraphicalStyleType; // ✅ new prop
  model?: Cnt.ThreeDeeCrate.SDK.CreateUpdateModelDTO;
  parentId?: string;
}

export const ModelForm: React.FC<ModelFormProps> = ({
  show,
  onClose,
  onSave,
  styleFilter,
  model,
  parentId
}) => {
  const isEditMode = !!model;

  const [name, setName] = useState(model?.Name || "");
  const [description, setDescription] = useState(model?.Description || "");
  const [price, setPrice] = useState<number>(model?.Price ?? 0);
  const [visibility, setVisibility] = useState<number>(
    model?.Visibility ?? Cnt.ThreeDeeCrate.SDK.VisibilityType.Private
  );

  // Reset when model changes
  useEffect(() => {
    if (model) {
      setName(model.Name ?? "");
      setDescription(model.Description ?? "");
      setPrice(model.Price ?? 0);
      setVisibility(model.Visibility ?? Cnt.ThreeDeeCrate.SDK.VisibilityType.Private);
    } else {
      setName("");
      setDescription("");
      setPrice(0);
      setVisibility(Cnt.ThreeDeeCrate.SDK.VisibilityType.Private);
    }
  }, [model]);

  const handleSubmit = () => {
    const dto: Cnt.ThreeDeeCrate.SDK.CreateUpdateModelDTO = {
      Id: model?.Id || EMPTY_GUID,
      ParentId: model?.ParentId || parentId || EMPTY_GUID,
      Name: name,
      Description: description,
      Price: price,
      Visibility: visibility,
      GraphicalStyle: styleFilter // ✅ comes from parent/URL
    };

    onSave(dto);
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{isEditMode ? "Edit Model" : "Create Model"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter model name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Price (in cents)</Form.Label>
            <Form.Control
              type="number"
              placeholder="Enter price in cents"
              value={price}
              onChange={(e) => setPrice(Number(e.target.value))}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Visibility</Form.Label>
            <Form.Select
              value={visibility}
              onChange={(e) => setVisibility(Number(e.target.value))}
            >
              <option value={Cnt.ThreeDeeCrate.SDK.VisibilityType.Private}>Private</option>
              <option value={Cnt.ThreeDeeCrate.SDK.VisibilityType.Public}>Public</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          {isEditMode ? "Update" : "Create"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
